module.exports = __webpack_public_path__ + "img/car_sendai15.ed3a741a.jpg";